/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '../../../base/bootstrap/css/bootstrap';
import './document.scss';
